import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

// utils
import { capitalize } from '../../../utils/text';

// Services
import LocalStorageService from '../../../services/LocalStorageService'
import ReportService from '../../../services/ReportService'
import FormService from '../../../services/FormService'

// Appt Components
import Box from '../../../components/simple/box/Box'
import DataTable from '../../../components/simple/dataTable/DataTable.js';
import DateTime from '../../../components/compound/dateTime/DateTime.js'
import Text from '../../../components/simple/text/Text'
import ActionButton from '../../../components/compound/actionButton/ActionButton.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Font Awesome

import moment from 'moment'
import PulseLoader from 'react-spinners/PulseLoader.js'
import { isServiceAdmin } from '../../../utils/permissions.js';

function Clickers (props) {
    const navigate = useNavigate()

    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [editingSubmissionId, setEditingSubmissionId] = useState(null)
    const [editingDate, setEditingDate] = useState('')
    const [editingTime, setEditingTime] = useState('00:00')
    const [savingSubmissionId, setSavingSubmissionId] = useState(null)
    const [saveError, setSaveError] = useState('')
    const [sort, setSort] = useState({
      property: 'clickerDate',
      direction: 'desc'
    })

    const apiToken = LocalStorageService.get('apiToken')
    const activeOrg = LocalStorageService.get('activeOrg')
    const currentUser = LocalStorageService.get('userDetails')

    const terms = LocalStorageService.get('terms')
    const params = useParams()
    const userId = params.userid

    const goBack = () => {
        navigate(-1)
    }

    useEffect(() => {
        (async () => {
            if (!userId) { return }
            await getData()
        })()
    }, [userId, params.userid])

    const getData = async () => {

      setLoading(true)

      const isAdmin = isServiceAdmin();
      let query = [
        {
          "key": "student",
          "operator": "is",
          "response": userId,
          "relation": null
        }
      ]
      if (!isAdmin) {
        query.push({
          "key": "recordedBy",
          "operator": "is",
          "response": String(currentUser.id),
          "relation": null
        })
      }

      let params = {
          orgId: activeOrg.id,
          studentId: String(userId),
          // limit: 100,
          // page: 1
        }

      const results = await ReportService.getReport(
        apiToken,
        {
          orgId: activeOrg.id,
          studentId: String(userId),
          // limit: 100,
          // page: 1
        },
        {
          submissionType: 'clicker',
          query: [
            // {
            //  "key": "subject",
            //   "operator": "is",
            //   "response": userId,
            //   "relation": null
            // }
          ],
          reports: [ isAdmin ? 'studentClickerSearch' : 'myStudentClickerSearch' ],
        },
      )

      if (results?.clickerSearch) {
        // let filteredResults = results.clickerSearch.filter(item => String(item.userId) === String(userId));

        // if (!isAdmin) {
        //   filteredResults = filteredResults.filter(item => String(item.recordedBy) === String(currentUser.id));
        // }

        setData(results?.clickerSearch)
      }

      setLoading(false)
    }

    const getClickerDateValue = datum => {
      if (datum?.clickerDate) {
        return datum.clickerDate
      }

      if (datum?.createdAt) {
        return datum.createdAt
      }

      return ''
    }

    const getEditingDateAndTime = datum => {
      const dateValue = getClickerDateValue(datum)
      if (!dateValue || !moment(dateValue).isValid()) {
        return {
          date: '',
          time: '00:00'
        }
      }

      return {
        date: moment(dateValue).format('YYYY-MM-DD'),
        time: moment(dateValue).format('HH:mm')
      }
    }

    const formatClickerDate = value => {
      if (!value || !moment(value).isValid()) {
        return ''
      }

      return moment(value).format('DD/MM/YYYY - HH:mm')
    }

    const startEditing = datum => {
      if (!datum?.clickerDateResponseId) {
        return
      }

      setSaveError('')
      setEditingSubmissionId(datum.id)
      const initialValues = getEditingDateAndTime(datum)
      setEditingDate(initialValues.date)
      setEditingTime(initialValues.time)
    }

    const saveClickerDate = async datum => {
      if (!datum?.clickerDateResponseId || !editingDate || !editingTime) {
        return
      }

      setSaveError('')
      setSavingSubmissionId(datum.id)

      try {
        const fullDateTime = moment(`${editingDate} ${editingTime}`, 'YYYY-MM-DD HH:mm', true)

        if (!fullDateTime.isValid()) {
          setSaveError('Please enter a valid date and time.')
          return
        }

        if (fullDateTime.isAfter(moment())) {
          setSaveError('Clicker date cannot be in the future.')
          return
        }

        await FormService.updateClickerDate(apiToken, datum.clickerDateResponseId, {
          response: fullDateTime.format('YYYY-MM-DD HH:mm:ss'),
        })

        await getData()
        setEditingSubmissionId(null)
        setEditingDate('')
        setEditingTime('00:00')
      } catch (err) {
        setSaveError(err?.response?.data?.error || 'Unable to save clicker date.')
      } finally {
        setSavingSubmissionId(null)
      }
    }

     const deleteReport = async submissionId => {
      if (window.confirm('Are you sure you want to delete this?')) {
        await FormService.updateSubmission(apiToken, submissionId, {
          status: 'Archived',
        });
        getData();
      }
    };


    let suTerm = capitalize(terms?.serviceUser || 'Service User')


     const resultColumns = [
         {
             property: 'clickerDate',
             label: 'Date',
              header: <Text pad='none' margin='none' color='secondary' weight='800'>Date</Text>,
             render: datum => (
               editingSubmissionId === datum.id ? (
                 <Box onClick={event => event.stopPropagation()} onFocus={event => event.stopPropagation()}>
                   <DateTime
                     date={editingDate}
                     time={editingTime}
                     setDateTime={(date, time) => {
                       setEditingDate(date)
                       setEditingTime(time || '00:00')
                     }}
                   />
                 </Box>
               ) : (
                 <Text>{formatClickerDate(getClickerDateValue(datum))}</Text>
               )
             )
           },
         {
           property: 'subType',
           label: 'Type',
           header: <Text pad='none' margin='none' color='secondary' weight='800'>Type</Text>
         },
         {
              property: 'actions',
              header: null,
              render: datum => (
                <>
                  <Box direction="row" width="100%">

                    {editingSubmissionId === datum.id && <ActionButton
                      plain
                      active={savingSubmissionId === datum.id || !editingDate || !editingTime}
                      onClick={() => {
                        saveClickerDate(datum)
                      }}
                      children={
                        <Box pad="5px">
                          <FontAwesomeIcon
                            icon={['fal', 'save']}
                            color="#ff8300"
                          />
                        </Box>
                      }
                    />}

                    {editingSubmissionId !== datum.id && <ActionButton
                      plain
                      active={!datum?.clickerDateResponseId}
                      onClick={() => {
                        startEditing(datum)
                      }}
                      children={
                        <Box pad="5px">
                          <FontAwesomeIcon
                            icon={['fal', 'edit']}
                            color="#ff8300"
                          />
                        </Box>
                      }
                    />}

                    {isServiceAdmin() && editingSubmissionId !== datum.id && <ActionButton
                      plain
                      onClick={() => {
                        deleteReport(datum.id);
                      }}
                      children={
                        <Box pad="5px">
                          <FontAwesomeIcon
                            icon={['fal', 'trash']}
                            color="#ff8300"
                          />
                        </Box>
                      }
                    />}
                  </Box>

                </>
              )
            }
       ]



  if (loading) {
    return <Box direction='row' gap='medium' >
      <Box background='white' direction='column' gap='small' margin={{ top: 'small', bottom: 'large' }} border={{ color: 'light-4', side: 'right' }} pad='medium' flex='grow'>
        <PulseLoader color='#ff8300' size={15} margin={5} />
      </Box>
    </Box>
  }

  return (
    <Box gridArea='main' background='white' direction='column' gap='small' round='small' margin={{ bottom: 'large' }}>
      <Box
        gap='small'
        round='small'
        margin={{ horizontal: 'small', top: 'small' }}
      >
        {saveError && <Text color='status-critical'>{saveError}</Text>}
        {!data.length && <Text>There are no results to display.</Text>}

        <DataTable
          columns={resultColumns}
          data={data}
          primaryKey="id"
          border={{ color: '#ddd' }}
          step={250}
          paginate={true}
          sort={sort}
          onSort={setSort}
        />
      </Box>
    </Box>
  )
}
export default Clickers
